<template>
  <div style="display: none">Loading...</div>
</template>
<script src="./index.js"></script>
